import React from 'react';
import {connect} from 'react-redux';
import * as BS from 'reactstrap';
import {doLogin} from '../actions';

import { Link } from 'react-router-dom';

const LoginPage = (props) => {
    return <section className="form">
        <div className="container container-md">

            <div className="row align-items-center justify-content-center">
                <div className="col-10 col-sm-8 align-self-center">
                    <div className="form-header">
                        <div className="text-center">
                            <h1>Logga in</h1>
                        </div>
                    </div>
                    <form>
                        <div>
                            <div className="form-group">
                                <input type="text" placeholder="Användarnamn" className="form-control"
                                       onChange={props.onFieldChange.bind(null, 'username')} value={ props.username }/>
                                <input type="password" placeholder="Lösenord" className="form-control"
                                       onChange={props.onFieldChange.bind(null, 'password')} value={ props.password }/>
                            </div>
                            <div className="text-center">
                                {props.loading && <div className="loader"></div>}
                                {!props.loading && <input type="submit" className="btn btn-success" onClick={props.onLoginClick} value="Fortsätt" />}
                            </div>
                            {props.status == 400 && <BS.Alert color="warning">Tyvärr, felaktiga uppgifter!</BS.Alert>}
                        </div>
                    </form>


                </div>
            </div>
        </div>

    </section>
}

export default connect(store => store.authState, (dispatch) => {
    return {
        onLoginClick: () => {
            doLogin(dispatch);
        },
        onFieldChange: (field, e) => {
            dispatch({
                type: 'AUTH_FIELD_CHANGE',
                field: field,
                value: e.target.value
            })
        }
    }
})(LoginPage);
